
import { Component, Prop, Vue } from 'vue-property-decorator';
import { RawLocation } from 'vue-router';
import MediaImg from 'spa-ionata-admin/lib/components/MediaImg.vue';
import AnOverline from '../components/AnOverline.vue';
import Business from '../models/Business';
import SectorAndCategroy from './SectorAndCategroy.vue';

@Component({ components: { AnOverline, SectorAndCategroy, MediaImg } })
export default class extends Vue {
  @Prop(Object) readonly business!: Business;

  get enquireTo(): RawLocation | undefined {
    const { slug } = this.business;
    if (!slug) {
      return undefined;
    }
    return { name: 'Enquiry', params: { slug } };
  }

  noop() {
    //
  }
}
